import algoliasearch from "algoliasearch/lite";

import { algoliaId, algoliaKey } from "../../.config/config";

const searchClient = algoliasearch(algoliaId, algoliaKey);

export const algoliaPlantEnumsRelevance = searchClient.initIndex("plantEnums");